import React, { useState } from 'react';
import ArticleMeta from '../../components/article-meta/ArticleMeta';

interface SavedArticleProps {
  id?: string;
  tagName?: string;
  tagLink?: string;
  title?: string;
  authorName?: string;
  authorLink?: string;
  publishDate?: string;
  readTime?: string;
  imageLink?: string;
  savedAt?: string;
  link?: string;
  articleRemoved: () => void;
}

const SavedArticle = ({
  id,
  tagName,
  tagLink,
  title,
  authorName,
  authorLink,
  publishDate,
  readTime,
  imageLink,
  savedAt,
  link,
  articleRemoved,
}: SavedArticleProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const getFallbackUrl = () => {
    const baseUrl = window.location.origin;
    return baseUrl + '/wp-content/themes/frontend/assets/images/forbes_placeholder.webp';
  };

  // Function to handle article removal
  const handleArticleRemoved = () => {
    articleRemoved();
  };

  return (
    <div className="saved-article">
      <div className="saved-article__content-wrapper">
        <div className="saved-article__content-top">
          {tagName && tagLink && (
            <a href={tagLink} className="saved-article__tag-link">
              <span className="tag">{tagName}</span>
            </a>
          )}

          {title && (
            <a href={link || '#'} className={`saved-article__title-link ${isHovered ? 'hovered' : ''}`}>
              <h6 className="saved-article__title heading h6-noto" dangerouslySetInnerHTML={{ __html: title }}></h6>
            </a>
          )}
        </div>

        {/* Pass the handleArticleRemoved function instead of articleRemoved directly */}
        <ArticleMeta
          removeArticle={handleArticleRemoved}
          savedAt={savedAt}
          articleAuthors={[{ name: authorName, link: authorLink }]}
          articleData={{
            id: id,
            title: title,
            url: link,
            image: imageLink,
            publishDate: publishDate,
            readTime: readTime,
          }}
        />
      </div>

      <a
        href={link || '#'}
        className="saved-article__image-wrapper"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {imageLink || imageLink === '' ? (
          <img src={imageLink} className="saved-article__image" alt={title} />
        ) : (
          <img className="saved-article__image" src={getFallbackUrl()} alt={title} />
        )}
      </a>
    </div>
  );
};

export default SavedArticle;
